/**
 * Pure discriminator for which availability endpoint a product uses.
 *
 * Kept in its own API-free module (no axios / @api imports) so it can be
 * consumed from Redux slices and unit tests without dragging in the HTTP
 * client chain. `cartHelper` re-exports it for backwards compatibility.
 *
 * SiteMinder accommodation (apiProviderId > 0 && groupFaresForAvailabilityCheck)
 * → checkAvailabilityByProductAndRange; everything else → the range endpoint.
 */
export const shouldCheckAvailabilityByGroup = (
    apiProviderId: number,
    groupFaresForAvailabilityCheck: boolean,
): boolean => apiProviderId > 0 && groupFaresForAvailabilityCheck;
